import { Button, Toolbar, Typography } from '@material-ui/core';
import { ToolbarComponentProps } from '@material-ui/pickers/Picker/Picker';
import React from 'react';
import styles from './KeyboardDatePickerToolbar.module.scss';
import classnames from 'classnames';
import moment from 'moment';

type Props = ToolbarComponentProps;

const DatePickerToolbar: React.FC<Props> = ({ date, openView, setOpenView }) => {
    return (
        <Toolbar classes={{ root: styles.root }}>
            <Button className={classnames(styles.button, openView === 'date' && styles.selected)} onClick={() => setOpenView('date')}>
                <Typography variant="h6">{moment(date).format('DD')}</Typography>
            </Button>
            <Button className={classnames(styles.button, openView === 'month' && styles.selected)} onClick={() => setOpenView('month')}>
                <Typography variant="h6">{moment(date).format('MMM')}</Typography>
            </Button>
            <Button className={classnames(styles.button, openView === 'year' && styles.selected)} onClick={() => setOpenView('year')}>
                <Typography variant="h6">{moment(date).format('YYYY')}</Typography>
            </Button>
        </Toolbar>
    );
};

export default DatePickerToolbar;
